import { FacebookFollowLink } from './FacebookFollowLink';

/**
 * @param {{ location: string; className?: string }} props
 */
export function FacebookGeneralDealsNudge({ location, className = '' }) {
  return (
    <div
      className={`search-alert-panel__facebook${className ? ` ${className}` : ''}`}
    >
      <p className="search-alert-panel__email-label">Follow on Facebook</p>
      <p className="search-alert-panel__facebook-lede">
        See Malta deals first — price drops, new local shops, and bargains
        we spot before they&apos;re gone.
      </p>
      <FacebookFollowLink location={location} />
    </div>
  );
}
